var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { GAME_RECEIVE_INFORMATION, GAME_UPDATE_STAGES, GAME_SET_CURRENT_STAGE_PAUSE, GAME_RECEIVE_SINGLE_GAME_FROM_API, GAME_RECEIVE_STAGES_FROM_API, GAME_PURGE_ALL_DATA } from 'components/constants';
import { parseTranslation } from 'helpers/translationUtilities';
var initialState = {
    id: '',
    name: '',
    stage: [],
    stages: [],
    startAt: null,
    settings: {
        companyToCompany: false,
        companyToPlayer: false,
        playerToCompany: false,
        playerToPlayer: false
    },
    token: ''
};
export default (function (state, _a) {
    var _b, _c, _d, _e;
    if (state === void 0) { state = initialState; }
    var type = _a.type, payload = _a.payload;
    switch (type) {
        default:
            return state;
        case GAME_UPDATE_STAGES: {
            var plainStages = payload.map(function (s) { return ({
                id: s.id,
                name: s.name,
                ordinal: s.ordinal,
                duration: s.duration,
                active: s.active,
                startedAt: s.startedAt,
                pausedAt: s.pausedAt,
                endedAt: s.endedAt,
                stageName: s.stageName,
                description: s.description,
                spentTime: s.spentTime,
                discussionBreak: s.discussionBreak,
                continuedAt: s.continuedAt,
                pauseHistory: s.pauseHistory,
            }); });
            return __assign(__assign({}, state), { stages: setFirstStateStartedAtToGameStartedAt(plainStages, state) });
        }
        case GAME_SET_CURRENT_STAGE_PAUSE: {
            return __assign(__assign({}, state), { stages: getModifiedGameStages(payload.gameStageChange, state) });
        }
        case GAME_RECEIVE_STAGES_FROM_API: {
            var stages = payload.map(function (stage) { return (__assign(__assign({}, stage), { stageName: parseTranslation(stage.stageName, 'et_EE') })); });
            return __assign(__assign({}, state), { stages: stages });
        }
        case GAME_RECEIVE_INFORMATION: {
            return __assign(__assign({}, state), { stages: [], id: payload.id || payload._id, name: payload.name, startAt: payload.startAt, settings: {
                    companyToCompany: !!((_b = payload.settings) === null || _b === void 0 ? void 0 : _b.companyToCompany),
                    companyToPlayer: !!((_c = payload.settings) === null || _c === void 0 ? void 0 : _c.companyToPlayer),
                    playerToCompany: !!((_d = payload.settings) === null || _d === void 0 ? void 0 : _d.playerToCompany),
                    playerToPlayer: !!((_e = payload.settings) === null || _e === void 0 ? void 0 : _e.playerToPlayer),
                }, taskSettings: payload.taskSettings ? {
                    playerCards: !!payload.taskSettings.playerCards,
                    companyCards: !!payload.taskSettings.companyCards,
                } : null, token: payload.token });
        }
        case GAME_PURGE_ALL_DATA: {
            return __assign({}, initialState);
        }
        case GAME_RECEIVE_SINGLE_GAME_FROM_API: {
            var stages = payload.stages.map(function (stage) {
                return __assign(__assign({}, stage), { title: parseTranslation(stage.title, 'et_EE') });
            });
            return __assign(__assign({}, state), { stages: stages, id: payload._id, name: payload.name, settings: {
                    companyToCompany: payload.transactionSettings.companyToCompany,
                    companyToPlayer: payload.transactionSettings.companyToPlayer,
                    playerToCompany: payload.transactionSettings.playerToCompany,
                    playerToPlayer: payload.transactionSettings.playerToPlayer
                }, token: payload.token });
        }
    }
});
var setFirstStateStartedAtToGameStartedAt = function (stages, game) {
    if (stages[0] && !stages[0].startedAt) {
        return __spreadArray([
            __assign(__assign({}, stages[0]), { startedAt: game.startAt })
        ], stages.slice(1), true);
    }
    return stages;
};
var getModifiedGameStages = function (gameStageChange, game) {
    var stageId = gameStageChange.stageId, StageStatus = gameStageChange.StageStatus;
    var stages = game.stages.map(function (stage) {
        if (stage.id !== stageId) {
            if (StageStatus === 'STARTED') {
                return __assign(__assign({}, stage), { active: false });
            }
            return stage;
        }
        if (StageStatus === 'STARTED')
            return __assign(__assign({}, stage), { pausedAt: 0, active: true });
        if (StageStatus === 'PAUSED')
            return __assign(__assign({}, stage), { pausedAt: 1 });
        return stage;
    });
    return setFirstStateStartedAtToGameStartedAt(stages, game);
};
